export default __webpack_public_path__ + "static/media/Clock dark.c560e103.svg";